import 'bootstrap';
import Sharer from 'sharer.js';

import Nav from './components/nav';
import Slider from './components/swiper';
import slab_Masonry from './components/masonry';
import Selects from './components/selects';
import Animations from './components/animations';

import './components/script.js';


const initScripts = () => {
    new Nav();
    new Slider();
    new slab_Masonry();
    new Selects();
    new Animations();
}

document.addEventListener("DOMContentLoaded", function () {
    initScripts();
});

